import {
  call, put, select, takeEvery,
} from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import findResult from '@/utils/resultsHelper';
import selectors from '@/selectors';
import DatasetSubscriptionsService from '@/notifications/subscribers/service';
import { datasetSubscriptions } from '@/notifications/subscribers/constants';
import { requestDatasetCode } from '../../state/state';
import {
  subscribeToRequestDatatsetSuccess,
  subscribeToRequestDatatsetError,
  fetchRequestUserSubscriptionsSuccess,
  fetchRequestUserSubscriptionsError,
} from '../actions';
import actions from '../constants';

export function* subscribe({ category, code }) {
  const items = yield select(selectors.requests);
  const item = findResult(items, category, code);
  const [source] = item.steps.results;
  const datasetCode = requestDatasetCode(item, source);
  const { response, error } = yield call(callAdapter, DatasetSubscriptionsService.subscribe(
    datasetCode,
    datasetSubscriptions.DATASET_UPDATE,
  ));

  if (error) {
    yield put(subscribeToRequestDatatsetError(category, code, error));
  } else {
    yield put(subscribeToRequestDatatsetSuccess(category, code, datasetCode, response));
  }
}

export function* subscriptions({ category, code }) {
  const items = yield select(selectors.requests);
  const item = findResult(items, category, code);
  const [source] = item.steps.results;
  const datasetCode = requestDatasetCode(item, source);
  const { response, error } = yield call(callAdapter, DatasetSubscriptionsService.subscriptions(datasetCode));

  if (error) {
    yield put(fetchRequestUserSubscriptionsError(category, code, error));
  } else {
    yield put(fetchRequestUserSubscriptionsSuccess(category, code, response.items));
  }
}

export default function* requestSubscriptionsApi() {
  yield takeEvery(actions.FETCH_REQUEST_USER_SUBSCRIPTIONS, subscriptions);
  yield takeEvery(actions.SUBSCRIBE_TO_REQUEST_DATASET, subscribe);
}
